import { createIcon as o } from "../createIcon.js";
const c = {
  name: "ArrowUpLongIcon",
  height: 512,
  width: 384,
  svgPath: "M214.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 109.3 160 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-370.7 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128z",
  yOffset: 0,
  xOffset: 0
}, t = o(c);
export {
  t as ArrowUpLongIcon,
  c as ArrowUpLongIconConfig,
  t as default
};
